import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { siteInfo } from '@/mocks/data';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 pb-4 min-h-screen">
        <div className="max-w-[1000px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mt-8 mb-10">
            <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
              关于<strong className="text-primary-500">黑料视频</strong>
            </h1>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base max-w-3xl">
              {siteInfo.description}
            </p>
          </section>

          <section className="mb-10">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {siteInfo.reputation.map((item) => (
                <div
                  key={item.label}
                  className="bg-background-100 border border-background-200/70 rounded-lg p-5 text-center"
                >
                  <div className="text-2xl md:text-3xl font-bold font-heading text-primary-500 mb-1">
                    {item.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500">{item.label}</div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-6">
              品牌口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-100 border border-background-200/70 rounded-lg p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <h3 className="font-semibold text-foreground-950 mb-2">内容真实可靠</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  我们拥有专业的编辑审核团队，对所有内容进行严格把关，确保为用户提供真实、准确的爆料信息。
                </p>
              </div>
              <div className="bg-background-100 border border-background-200/70 rounded-lg p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-speed-up-line text-lg"></i>
                </div>
                <h3 className="font-semibold text-foreground-950 mb-2">更新速度领先</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  7×24小时不间断更新，第一时间为您带来最新爆料。热点事件发生后最快10分钟内即可观看相关视频。
                </p>
              </div>
              <div className="bg-background-100 border border-background-200/70 rounded-lg p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-3">
                  <i className="ri-user-heart-line text-lg"></i>
                </div>
                <h3 className="font-semibold text-foreground-950 mb-2">用户体验至上</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  高清流畅的播放体验，简洁易用的界面设计。无需注册登录，打开即看，让观看爆料视频变得轻松愉快。
                </p>
              </div>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-6">
              常见问题
            </h2>
            <div className="space-y-3">
              {siteInfo.faqs.map((faq, index) => (
                <details
                  key={index}
                  className="bg-background-100 border border-background-200/70 rounded-lg group"
                >
                  <summary className="px-5 py-4 cursor-pointer font-medium text-foreground-900 text-sm md:text-base flex items-center justify-between">
                    {faq.question}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform ml-2"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-6">
              联系我们
            </h2>
            <div className="bg-background-100 border border-background-200/70 rounded-lg p-6">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">电子邮箱</div>
                    <div className="text-sm font-medium text-foreground-900">{siteInfo.email}</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 shrink-0">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">联系电话</div>
                    <div className="text-sm font-medium text-foreground-900">{siteInfo.phone}</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 shrink-0">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">公司地址</div>
                    <div className="text-sm font-medium text-foreground-900">{siteInfo.address}</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于黑料视频',
            description: siteInfo.description,
            url: 'https://heiliaoshipin.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '黑料视频',
              url: 'https://heiliaoshipin.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: siteInfo.faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '黑料视频',
            url: 'https://heiliaoshipin.com/',
            description: siteInfo.description,
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: siteInfo.phone,
              contactType: 'customer service',
              email: siteInfo.email,
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: siteInfo.address,
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://heiliaoshipin.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
              },
            ],
          }),
        }}
      />
    </>
  );
}